import type { ContainerComponentProps } from "../../core/types";

/**
 * Zoom recommends using a single <video-player-container> parent element,
 * for all user video components (<video-player>).
 * - Screen share based <video-player> should get their own <video-player-container>.
 *
 * This is supposed to optimize performance:
 * https://devforum.zoom.us/t/should-video-player-be-a-direct-child-of-video-player-container-help-needed/125828/4
 *
 * Base styling on the web component that can only be overridden via it's style attribute.
 */
export function ZoomVideoContainer({
  className,
  dataTestId,
  styleOverride,
  children,
}: ContainerComponentProps) {
  return (
    <video-player-container
      class={className}
      style={styleOverride}
      data-testid={dataTestId}
    >
      {children}
    </video-player-container>
  );
}
